import React from 'react';
import styled from 'styled-components';
import { ClockHand } from './assets/ClockHand';
import { Frame } from './assets/Frame';

type Props = {
  className?: string;
};

export const LoadingIcon: React.FC<Props> = ({ className }) => {
  return (
    <Container className={className}>
      <Clock />
      <Hand />
    </Container>
  );
};

export const Container = styled.div`
  width: 50px;
  height: 50px;
  position: relative;
`;

const Clock = styled(Frame)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
`;

const Hand = styled(ClockHand)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;

  animation: spin 2s infinite linear;
  animation-timing-function: ease-in-out;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
